import { defineStore } from 'pinia';

interface State {
  isObservationSwitchOn: boolean;
  /** 強制的に全てのデータを取得し直す */
  forceUpdateResult: boolean;
}

export const useStateStore = defineStore('state', {
  state: (): State => ({
    isObservationSwitchOn: false,
    forceUpdateResult: false,
  }),
  actions: {
    toggleObservationSwitch() {
      this.isObservationSwitchOn = !this.isObservationSwitchOn;
    },
    toggleForceUpdateResult() {
      this.forceUpdateResult = !this.forceUpdateResult;
    },
  },
});
